import PurchasePriceTable from './PurchasePriceTable';

export default PurchasePriceTable;
